import { IShipmentLocation } from '@cemex-core/cmx-api/models/shipment-location/shipment-location';
import { IAddress } from '@cemex-core/cmx-api/models/address/address.interface';
import {
  POD_LOAD,
  POD_LOAD_ADDRESS,
  POD_LOAD_ADDRESS_SUCCESS,
  POD_LOAD_COMPLETE,
  POD_LOAD_INITIAL_STATE,
  POD_LOAD_SALES_AREA_SUCCESS,
  POD_SET_AVAILABILITY,
  POD_SET,
  PODActions,
  POD_REMOVE_SELECTED_POD,
  POD_TOGGLE_SHOWING_POD_REQUESTS,
  POD_SET_REQUIRED,
} from '../../actions/point-of-delivery-actions/point-of-delivery.actions';
import { IRequestedAddressResponse } from '@cemex-core/cmx-api/models/addresses-req-management/addresses-response';
import { IPointOfDeliverySalesArea } from '@cemex-core/cmx-api/models/point-of-delivery-sales-areas/point-of-delivery-sales-area';
import { ILocationConfigUnit } from '../../models/location-config.interface';
import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';

export interface IPODState {
  required: boolean;
  loaded: boolean;
  visible: boolean;
  loading: boolean;
  pointOfDeliveries: IShipmentLocation[];
  selected: IShipmentLocation;
  address: IAddress | IRequestedAddressResponse;
  pointOfDeliverySalesArea: IPointOfDeliverySalesArea[];
  showRequestedPointOfDeliveries: boolean;
}

export const initialState: IPODState = {
  required: false,
  visible: false,
  loaded: false,
  loading: false,
  pointOfDeliveries: [],
  selected: null,
  address: null,
  pointOfDeliverySalesArea: [],
  showRequestedPointOfDeliveries: true,
};

export function PODReducer(state = initialState, action: PODActions | OrderBuilderActions): IPODState {
  switch (action.type) {
    case RESET_BUILDER:
    case POD_LOAD_INITIAL_STATE: {
      if (action.payload) {
        const podInitialState: ILocationConfigUnit = action.payload;
        return {
          ...state,
          disabled: podInitialState.disabled,
          required: podInitialState.required,
          visible: podInitialState.visible,
        } as IPODState;
      } else {
        return {
          ...initialState,
        };
      }
    }
    case POD_LOAD:
    case POD_LOAD_ADDRESS: {
      return {
        ...state,
        loading: true,
      } as IPODState;
    }
    case POD_LOAD_COMPLETE: {
      const shipmentLocations: IShipmentLocation[] = action.payload.shipmentLocations;
      return {
        ...state,
        loaded: true,
        loading: false,
        pointOfDeliveries: shipmentLocations,
      } as IPODState;
    }

    case POD_REMOVE_SELECTED_POD: {
      return {
        ...state,
        selected: null,
        address: null,
      } as IPODState;
    }

    case POD_SET: {
      return {
        ...state,
        selected: action.payload,
      } as IPODState;
    }
    case POD_SET_REQUIRED: {
      return {
        ...state,
        required: action.payload,
      } as IPODState;
    }
    case POD_LOAD_ADDRESS_SUCCESS: {
      return {
        ...state,
        loading: false,
        address: action.payload,
      } as IPODState;
    }
    case POD_LOAD_SALES_AREA_SUCCESS: {
      return {
        ...state,
        pointOfDeliverySalesArea: action.payload,
      } as IPODState;
    }
    case POD_SET_AVAILABILITY: {
      return {
        ...state,
        disabled: action.payload,
      } as IPODState;
    }
    case POD_TOGGLE_SHOWING_POD_REQUESTS: {
      return {
        ...state,
        showRequestedPointOfDeliveries: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
